import { useRouteUrl } from '@confluence/route-manager/entry-points/RouteState.ts';
import { useIsAIFCOnbardingEligible } from '@confluence/onboarding-ai-first-create/entry-points/useIsAIFCOnbardingEligible.ts';

import {
	useGetModernizeChangeboardingOnboardingState,
	useSetModernizeChangeboardingOnboardingState,
	STEPS,
} from '../../hooks/useModernizeChangeboardingOnboardingState.ts';
import type { SegmentHook } from '../../hooks/useCombinedSegments.tsx';
import { useModernizeChangeboardingTapTraits } from '../../hooks/useModernizeChangeboardingTapTraits.ts';

import { Spotlights } from './Spotlights.tsx';

export const useNav4SpaceSegment: SegmentHook = () => {
	const {
		loading: aifcLoading,
		error: aifcError,
		isAIFCOnbardingEligible,
	} = useIsAIFCOnbardingEligible();
	const {
		loading: onboardingLoading,
		error: onboardingError,
		isNav4SpaceTourDismissed,
	} = useGetModernizeChangeboardingOnboardingState();
	const {
		loading: tapLoading,
		error: tapError,
		isInNav4Audience,
		hasDismissedNav4ChangeboardingViaEP,
	} = useModernizeChangeboardingTapTraits();
	const { completeNav4SpaceTour } = useSetModernizeChangeboardingOnboardingState();

	const isOnNonSettingsSpaceRoute = useRouteUrl(isOnNonSettingsSpaceRouteSelector);

	const showNav4SpaceTour =
		!isAIFCOnbardingEligible &&
		isOnNonSettingsSpaceRoute &&
		isInNav4Audience &&
		!hasDismissedNav4ChangeboardingViaEP &&
		!isNav4SpaceTourDismissed;

	const loading = onboardingLoading || tapLoading || aifcLoading;
	const error = onboardingError || tapError || aifcError;

	if (loading) {
		return {
			steps: [],
			onComplete: () => {},
			loading: true,
		};
	}

	if (error) {
		return {
			steps: [],
			onComplete: () => {},
			error,
		};
	}

	if (!showNav4SpaceTour) {
		return {
			steps: [],
			onComplete: () => {},
		};
	}

	const steps = [Spotlights.Nav4CollapseSpotlight, Spotlights.Nav4SpaceSettingsSpotlight];

	return {
		stepsToComplete: [STEPS.NAV_4_SPACE],
		steps,
		onComplete: completeNav4SpaceTour,
	};
};

const isOnNonSettingsSpaceRouteSelector = {
	selector: (routeUrl: string | undefined) => {
		if (!routeUrl) {
			return false;
		}

		return /\/wiki\/spaces\/[^/]+(\/(?!settings).*)?$/.test(routeUrl);
	},
};
